/** Number of GitHub repos shown when the card is collapsed. */
export const COLLAPSED_REPO_COUNT = 3;

/** Number of GitHub repos shown when the card is expanded (matches design). */
export const EXPANDED_REPO_COUNT = 9;
